module.exports = __webpack_public_path__ + "img/bg.6eb0fd6e.png";